import React, { FC } from 'react';

import { IDynamicComponent } from 'plugins/api/types';

import { EditPanel, TablePanel, ListPanel } from 'plugins/components/containers';

import 'plugins/theme/components/EditPanel/EditPanel.scss';

// typ danych wejściowych
interface IProps {
  pageSymbol: string;
  components?: IDynamicComponent[];
  requestParams?: object;
  horizontal?: boolean;
}

const DynamicSwitchComponent: FC<IProps> = ({ pageSymbol, components, requestParams }) => {
  const renderContent = () => {
    if (components) {
      return components?.map((component, i) => {
        if (component.type === 'tablePanel') {
          return (
            <TablePanel
              label={component.label}
              filters={component.filters}
              actions={component.actions}
              columns={component.columns}
              loadDataParams={component.load_data_params}
              pageSymbol={pageSymbol}
              componentSymbol={component.symbol}
              requestParams={requestParams}
              isSubComponent
              key={i}
            />
          );
        }

        if (component.type === 'editPanel') {
          return (
            <EditPanel
              label={component.label}
              fields={component.fields}
              actions={component.actions}
              isModal={false}
              loadDataParams={component.load_data_params}
              pageSymbol={pageSymbol}
              componentSymbol={component.symbol}
              requestParams={requestParams}
              key={i}
            />
          );
        }

        if (component.type === 'verticalPanel' || component.type === 'listHorizontalPanel') {
          return (
            <ListPanel
              pageSymbol={pageSymbol}
              components={component.components}
              requestParams={requestParams}
              horizontal={component.type === 'listHorizontalPanel'}
              key={i}
            />
          );
        }

        return null;
      });
    }

    return null;
  };

  return <>{renderContent()}</>;
};

export default DynamicSwitchComponent;
